import { AbsoluteFill, Img } from "remotion";

export const BackgroundLayer: React.FC<{ url: string; seed: number }> = ({
	url,
}) => {
	return (
		<AbsoluteFill style={{ backgroundColor: "#000", overflow: "hidden" }}>
			<Img
				src={url}
				style={{
					width: "100%",
					height: "100%",
					objectFit: "cover",
				}}
			/>
		</AbsoluteFill>
	);
};
